import { getHistory } from '../routing/history';
import { createUuid } from '../tracking/createUuid';
export const getUserExperimentIdentifier = () => {
  const searchParams = new URLSearchParams(getHistory().location.search);
  const experimentIdentifier = searchParams.get('uuid') || createUuid();
  return experimentIdentifier;
};